
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    /* eslint-disable no-console */
import LINKS from '@constants/links';
import { getRecipe } from '@features/recipes/api';
import { formatImgUrl } from '@features/recipes/helpers';
import { default as RecipeDetailsPage } from '@features/recipes/RecipeDetailsPage';
import { getRecipeKey } from '@features/recipes/RecipeDetailsPage/useRecipe';
import CanonicalLink from '@features/seo/CanonicalLink';
import { createSwrCmsLayoutFallback, recipesRevalidationInterval } from '@helpers/fallback';
import useConfig from '@hooks/useConfig';
import { AxfoodApi } from '@occ/api-client';
import { GetStaticPathsResult, GetStaticPropsContext } from 'next';
import useTranslation from 'next-translate/useTranslation';
import Head from 'next/head';
import { unstable_serialize } from 'swr';
const notPreviewPage = false;
interface Props {
    id: string;
    name: string;
    imageUrl?: string;
    canonicalUrl: string;
}
const RecipePage = ({ id, name, imageUrl, canonicalUrl }: Props) => {
    const { t } = useTranslation('common');
    const { config } = useConfig();
    if (!id) {
        return null;
    }
    return (<>
      <Head>
        <title>{`${name}${t('common:seo->defaultTitleSuffix')}`}</title>
        <meta name="description" key="description" content={t('recipes:metaDescriptionRecipeDetail')}/>
        <meta property="og:title" key="og:title" content={t('common:seo->defaultOgTitle')}/>
        <meta property="og:description" key="og:description" content={t('common:seo->defaultOgDescription')}/>
        <meta property="og:url" key="og:url" content={config?.PUBLIC_HOST}/>
        {imageUrl && <meta property="og:image" key="og:image" content={formatImgUrl(imageUrl, '1200', '630')}/>}
      </Head>
      <CanonicalLink url={canonicalUrl}/>
      <RecipeDetailsPage recipeId={id}/>
    </>);
};
export default RecipePage;
export const getStaticPaths = async (): Promise<GetStaticPathsResult> => {
    return { paths: [], fallback: 'blocking' };
};
const revalidationInterval = recipesRevalidationInterval;
const fallbackReturn = {
    notFound: true,
    revalidate: revalidationInterval, // revalidate even for 404s, to avoid temporary errors caches indefinitely
};
const api = new AxfoodApi({
    baseUrl: global.process.env.SERVER_API_HOST,
    baseApiParams: {
        headers: {
            'x-api-key': global.process.env.X_API_KEY || '',
        },
    },
});
const getStaticProps = async ({ params: { id } = {} }: GetStaticPropsContext) => {
    if (!id) {
        console.error('Invalid id provided');
        return fallbackReturn;
    }
    try {
        const cmsPageFallback = createSwrCmsLayoutFallback();
        const canonicalUrl = `${process.env.SERVER_API_HOST}${LINKS.RECIPE}${id}`;
        const { formattedProductsAtHome, formattedProductsToBuy, ...recipeWithoutProducts } = await getRecipe(id as string, api);
        if (!recipeWithoutProducts) {
            console.error(`Recipe request succeeded but returned invalid data: ${id}`);
            return fallbackReturn;
        }
        const recipeKey = getRecipeKey(recipeWithoutProducts.id, notPreviewPage);
        const recipeFallback = { [unstable_serialize(recipeKey)]: recipeWithoutProducts };
        return {
            props: {
                id,
                name: recipeWithoutProducts.name,
                imageUrl: recipeWithoutProducts.imageUrl,
                canonicalUrl,
                fallback: {
                    ...cmsPageFallback,
                    ...recipeFallback,
                },
            },
            revalidate: revalidationInterval,
        };
    }
    catch (error) {
        console.error(`Error fetching recipe for id: ${id}`, error);
        return fallbackReturn;
    }
};

    async function __Next_Translate__getStaticProps__19ae8534df4__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/recept/[id]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19ae8534df4__ as getStaticProps }
  